<template>
  <router-link
    :to="customLink"
    class="img-box sm-ratio box-index"
  >
    <img 
      class="offer-img-home" 
      :src="src" 
      alt="ofertas"
      loading="lazy"
    />
  </router-link>
</template>

<script>
export default {
  name: 'BannerItem',
  props: {
    src: String,
    link: String,
    idImg: String,
  },
  computed: {
    customLink() {
      const linksMap = {
        '5': '/shop',
        '6': '/shop/brands/46?text=CORSAIR',
        '7': '/shop/brands/3?text=LOGITECH',
        '8': '/shop/brands/8?text=MSI',
      }
      return this.link || linksMap[this.idImg] || '/shop'
    },
  },
}
</script>

<style scoped>
.offer-img-home {
  width: 100%;
  aspect-ratio: 19 / 10; 
  border-radius: 12px; 
  object-fit: cover;
  background-color: #fff; 
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
</style>